'use client';

import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import { RichText } from '@/components/richText/RichText';
import { SwdRadio } from '@/components/swdRadio/SwdRadio';
import { hasContent } from '@/helper/RichText';
import type { RichtextStoryblok } from '@/types/component-types-sb';
import type { MouseEvent, ReactNode } from 'react';

import classes from './B2BRadioCard.module.scss';

export type B2BRadioCardProps = {
  name: string;
  value: string;
  checked?: string | boolean;
  headline1: string | undefined;
  headline2: string | undefined;
  subtitle1: string | undefined;
  subtitle2: string | undefined;
  infoContent: RichtextStoryblok | undefined;
  description: string | undefined;
  dataTestId?: string;
  trackingCategory?: string;
  trackingLabel?: string;
};

export const B2BRadioCards: React.FC<{ children: ReactNode }> = (props) => {
  return <div className={classes.cards}>{props.children}</div>;
};

const stopLabelActivation = (event: MouseEvent<HTMLDivElement>): void => {
  event.preventDefault();
  event.stopPropagation();
};

const B2BRadioCard: React.FC<B2BRadioCardProps> = (props) => {
  const trackingLabel = props.trackingLabel ?? '';
  const ariaLabel = [props.headline1, props.subtitle1, props.headline2, props.subtitle2].filter(Boolean).join(' ');

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <label className={classes.control} aria-label={ariaLabel}>
          <SwdRadio data-testid={props.dataTestId} value={props.value} />
          <div className={classes.headlines}>
            {props.headline1 || props.subtitle1 ? (
              <div className={classes.headline}>
                {props.headline1 ? <span className={classes.title}>{props.headline1}</span> : null}
                {props.subtitle1 ? <span className={classes.subtitle}>{props.subtitle1}</span> : null}
              </div>
            ) : null}
            {props.headline2 || props.subtitle2 ? (
              <div className={classes.headline}>
                {props.headline2 ? <span className={classes.title}>{props.headline2}</span> : null}
                {props.subtitle2 ? <span className={classes.subtitle}>{props.subtitle2}</span> : null}
              </div>
            ) : null}
          </div>
          {hasContent(props.infoContent) ? (
            <div className={classes.infoButton} onClick={stopLabelActivation} onMouseDown={stopLabelActivation}>
              <InfoIconModal trackingLabel={trackingLabel}>
                <RichText text={props.infoContent} />
              </InfoIconModal>
            </div>
          ) : null}
        </label>
      </div>
      {props.description ? <p className={classes.description}>{props.description}</p> : null}
    </div>
  );
};

export default B2BRadioCard;
